import { createReducer } from '@reduxjs/toolkit';
import { fetch, success, error } from './actions';

import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: undefined,
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetch, (state) => {
      state.status = 'loading';
      state.data = undefined;
      state.error = undefined;
    })
    .addCase(success, (state, action) => {
      const { payload } = action;
      state.data = payload;
      state.error = undefined;
      state.status = 'success';
    })
    .addCase(error, (state, action) => {
      const { payload } = action;

      state.error = payload;
      state.status = 'error';
    })
);
